import { appConfig } from '../constants';
import { setRuntimeConfig } from './runtimeConfig';

const LOCAL_CONFIG_URL = '/config.json';

export async function initRuntimeConfig(): Promise<void> {
  const isLocalhost = window.location.hostname === 'localhost';
  const url = isLocalhost ? LOCAL_CONFIG_URL : appConfig.configUrl;

  if (!url) return;

  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const config = (await res.json()) as {
      authAuthority?: string;
      authClientId?: string;
      authClientSecret?: string;
    };
    setRuntimeConfig(config);
  } catch {
    // fall back to static appConfig values
  }
}
